// extracted by mini-css-extract-plugin
export var border = "_p-7";
export var brand = "_p-s";
export var button = "_p-k";
export var center = "_p-9";
export var centered = "_p-5";
export var closeButton = "_p-b";
export var disabledWrapper = "_p-l";
export var error = "_p-o";
export var extraLarge = "_p-4";
export var extraSmall = "_p-1";
export var fill = "_p-h";
export var footer = "_p-g";
export var footerAction = "_p-i";
export var footerButtons = "_p-j";
export var header = "_p-6";
export var headerWithClose = "_p-c";
export var icon = "_p-n";
export var info = "_p-r";
export var inline = "_p-8";
export var large = "_p-3";
export var main = "_p-d";
export var modal = "_p-0";
export var neutral = "_p-t";
export var noPadding = "_p-f";
export var none = "_p-u";
export var scrollable = "_p-e";
export var small = "_p-2";
export var success = "_p-q";
export var tight = "_p-m";
export var titleIcon = "_p-a";
export var warn = "_p-p";